import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import { useState } from "react";
// import ContestDialogImage from "./../assets/Contest Dialog.jpg";
import ContestDialogImage from "./../assets/Contest Dialog2.jpg";
// import ContestBannerImage from "./../assets/Contest Banner.jpg";
import ContestBannerImage from "./../assets/Contest Banner2.jpg";
import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import "./Dashboard.css";
import MappingService from "../services/MappingService";
import ProductService from "../services/ProductService";
import ReactCountryDropdown from "react-country-dropdown";

const dialogStyles = makeStyles((theme) => ({
  backDrop: {
    backdropFilter: "blur(5px)",
    backgroundColor: "rgba(0,0,30,0.4)",
  },
}));

const Dashboard = () => {
  const mappingService = new MappingService();
  const productService = new ProductService();
  const classes = dialogStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isIPLContestEligible, setIsIPLContestEligible] = useState(false);
  const [isIPLContestDialog, setIsIPLContestDialog] = useState(false);
  const [country, setCountry] = useState("IN");
  const [countryCode, setCountryCode] = useState("+91");
  const [boughtFromIndia] = useState([
    { key: "ONWebsite", value: "Optimum Nutrition India Website" },
    { key: "Amazon", value: "Amazon" },
    { key: "Flipkart", value: "Flipkart" },
    { key: "Blinkit", value: "Blinkit" },
    { key: "SwiggyInstamart", value: "Swiggy Instamart" },
    { key: "Zepto", value: "Zepto" },
    { key: "Other", value: "Other online store" },
    { key: "NearYou", value: "A Store near you" },
  ]);
  const [boughtFromUAE] = useState([
    { key: "Amazon", value: "Amazon" },
    { key: "Noon", value: "Noon" },
    { key: "OtherOnlineSite", value: "Other Online Site" },
  ]);
  const [boughtFromOthers] = useState([
    { key: "D2CWebsite", value: "D2C Website" },
    { key: "Amazon", value: "Amazon" },
    { key: "OtherOnlineSite", value: "Other Online Site" },
    { key: "NearYou", value: "A Store near you" },
  ]);
  const [boughtFrom, setBoughtFrom] = useState(boughtFromIndia);

  const [formData, setFormData] = useState({
    code: "",
    mobileNumber: "",
    email: "",
    onlineStore: "",
    CurrentLocation: "",
    state: "",
    qrTrackingId: "",
    brandId: "",
    city: "", // Added
    pincode: "", // Added
    country: "", // Added
    lat: "", // Added
    lon: "", // Added
  });
  const [errors, setErrors] = useState({});

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const validationErrors = {};
      if (!formData.code) {
        validationErrors.code = "Code is required";
      } else if (!/^[A-Z0-9]{6}$/.test(formData.code)) {
        validationErrors.code = "Code must be 6 uppercase letters or digits";
      }

      if (!formData.mobileNumber) {
        validationErrors.mobileNumber = "Mobile number is required";
      } else if (
        countryCode == "+91" &&
        !formData.mobileNumber.match(/^[6-9]\d{9}$/)
      ) {
        validationErrors.mobileNumber = "Please enter valid mobile number.";
      } else if (
        countryCode == "+971" &&
        !formData.mobileNumber.match(/^(?:50|51|52|55|56|2|3|4|6|7|9)\d{7}$/)
      ) {
        validationErrors.mobileNumber = "Please enter valid mobile number.";
      }

      if (!formData.onlineStore) {
        validationErrors.onlineStore = "Online store selection is required";
      }
      if (isIPLContestEligible) {
        if (!formData.email) {
          validationErrors.email = "Email is required";
        }
      }
      if (
        formData.email &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
      ) {
        validationErrors.email = "Please enter a valid email address";
      }
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length === 0) {
        mappingService.authenticateData(formData).then(async (response) => {
          if (response.responseCode === "200") {
            const currentUrl = window.location.href;
            const data = {
              U: currentUrl,
              CurrentLocation: formData.CurrentLocation,
              state: formData.state,
              ScratchCode: formData.code,
              MobileNumber: countryCode + formData.mobileNumber,
              Email: formData.email,
              OnlineStore: formData.onlineStore,
              QRTrackingId: formData.qrTrackingId,
              brandId: formData.brandId,
              City: formData.city,
              Pincode: formData.pincode,
              Country: formData.country,
              Lat: formData.lat,
              Long: formData.lon,
            };

            productService
              .QRScratchTracking(data)
              .then(async (responseQRScratch) => {
                if (
                  responseQRScratch[0].status === "Fake Product" ||
                  responseQRScratch[0].status === "Number not mapped" ||
                  responseQRScratch[0].status === "Seq No exists in damage"
                ) {
                  setTimeout(() => {
                    setLoading(true);
                    navigate("/fake", {
                      state: {
                        QRData: data.U,
                        verificationLogId: responseQRScratch[0].id,
                        brandId: formData.brandId,
                      },
                    });
                  }, 1000);
                } else {
                  setTimeout(
                    () =>
                      navigate("/genuine", {
                        state: {
                          ResponseData: response,
                          ResQRScratch: responseQRScratch[0],
                          mobileNo: countryCode + formData.mobileNumber,
                          brandId: formData.brandId,
                        },
                      }),
                    1000,
                  );
                }
              });
          } else {
            const currentUrl = window.location.href;
            const data = {
              U: currentUrl,
              CurrentLocation: formData.CurrentLocation || "",
              state: formData.state,
              ScratchCode: formData.code,
              MobileNumber: countryCode + formData.mobileNumber,
              Email: formData.email,
              OnlineStore: formData.onlineStore,
              QRTrackingId: formData.qrTrackingId,
              brandId: formData.brandId,
              City: formData.city,
              Pincode: formData.pincode,
              Country: formData.country,
              Lat: formData.lat,
              Long: formData.lon,
            };
            productService
              .QRScratchTracking(data)
              .then(async (responseQRScratch) => {
                navigate("/fake", {
                  state: {
                    QRData: data.U,
                    verificationLogId: responseQRScratch[0].id,
                    brandId: formData.brandId,
                  },
                });
              });
          }
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    const getUserGeolocation = () => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            getCityFromCoordinates(position.coords);
          },
          (error) => {
            console.error("Error getting user location:", error);
            InsertQRTrackingData("", "", "", "", "", "");
          },
        );
      } else {
        console.error("Geolocation is not supported");
        InsertQRTrackingData("", "", "", "", "", "");
      }
    };
    getUserGeolocation();
  }, []);

  const InsertQRTrackingData = async (
    compAdd,
    state,
    city,
    pincode,
    country,
    lat,
    lon,
  ) => {
    setLoading(true);
    try {
      const currentUrl = window.location.href;
      const data = {
        U: currentUrl,
        CurrentLocation: compAdd,
        state: state,
        City: city, // Added
        Pincode: pincode, // Added
        Country: country, // Added
        Lat: lat, // Added
        Long: lon, // Added
      };

      try {
        productService.QRTracking(data).then(async (response) => {
          if (response) {
            setFormData((prevFormData) => ({
              ...prevFormData,
              qrTrackingId: response[0].qrTrackingId,
              brandId: response[0].brandId,
            }));
            setIsIPLContestEligible(response[0].isIPLContestEligible);
            setIsIPLContestDialog(response[0].isIPLContestEligible);
            setLoading(false);
          } else {
            console.error("API Error:", response);
            setLoading(false);
          }
        });
      } catch (error) {
        console.error("Request Error:", error);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
    }
  };

  const getCityFromCoordinates = async (userLocation) => {
    try {
      let data;
      let response;
      do {
        response = await getLocation(userLocation);
        data = await response.json();
      } while (!data);
      if (data.address) {
        const addressComponents = [
          data.address.road,
          data.address.industrial,
          data.address.suburb,
          data.address.city,
          data.address.town,
          data.address.state_district,
          data.address.state,
          data.address.postcode,
          data.address.country,
        ];

        const filteredAddressComponents = addressComponents.filter(
          (component) => component !== undefined,
        );
        let city =
          data.address.city ||
          data.address.town ||
          data.address.village ||
          data.address.county;
        let state = data.address.state || data.address.state_district;
        const completeAddress = filteredAddressComponents.join(" ");

        setFormData((prevFormData) => ({
          ...prevFormData,
          CurrentLocation: completeAddress, // Now only contains address components
          state: state,
          city: city,
          pincode: data.address.postcode,
          country: data.address.country,
          lat: data.lat,
          lon: data.lon,
        }));
        InsertQRTrackingData(
          completeAddress, // No coordinates here
          state,
          city,
          data.address.postcode,
          data.address.country,
          data.lat,
          data.lon,
        );
        if (!city) {
          city = data.address.state;
        }

        return city || "City not found";
      } else {
        return "City not found";
      }
    } catch (error) {
      console.error("Error fetching city:", error);
      InsertQRTrackingData("", "", "", "", "", "");
      return "Error fetching city";
    }
  };

  const getLocation = async (userLocation) => {
    const apiUrl = `https://geocode.maps.co/reverse?lat=${userLocation.latitude}&lon=${userLocation.longitude}&api_key=665dcea61841b296785394ivz8480ad`;
    const response = await fetch(apiUrl);
    return response;
  };

  const onCountryChange = (country) => {
    setCountry(country.code);
    setCountryCode("+" + country.callingCodes[0]);
    if (country.code === "AE") {
      setBoughtFrom(boughtFromUAE);
    } else if (country.code === "IN") {
      setBoughtFrom(boughtFromIndia);
    } else {
      setBoughtFrom(boughtFromOthers);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <section id="venue">
            <div className="container-fluid">
              <div
                hidden={!isIPLContestEligible}
                className="row slidere-bg animate-in-down text-center"
              >
                <div className="text-center banner-img pr-md-3">
                  <img src={ContestBannerImage} />
                </div>
              </div>
              <div className="row slidere-bg animate-in-down ">
                <div className=" col-md-4 align-self-center text-white slidere dash">
                  <div className="container ">
                    <div className="form-container pa" id="login-form">
                      <h3 className="blink-text">Product Authentication</h3>
                      <form onSubmit={handleFormSubmit}>
                        <input
                          type="text"
                          name="code"
                          placeholder="Enter your 6 Digit code here *"
                          className="mar-tp-16 b-input"
                          maxLength={6}
                          value={formData.code}
                          onChange={handleInputChange}
                        />
                        {errors.code && (
                          <div className="text-red-500">{errors.code}</div>
                        )}
                        <h5 className="varification">
                          <p>
                            The 6-Digit code is located under the Scratch area
                            on the sticker. Pls scratch it off to reveal the
                            code.
                          </p>
                        </h5>
                        <div className="row">
                          <div style={{ width: "33.33%", padding: "0 15px" }}>
                            <ReactCountryDropdown
                              defaultCountry={country}
                              onSelect={(country) => {
                                onCountryChange(country);
                              }}
                            />
                          </div>
                          <div style={{ width: "66.67%", padding: "0 15px" }}>
                            <input
                              style={{ width: "100%" }}
                              type="text"
                              name="mobileNumber"
                              placeholder="Enter your mobile number *"
                              className="mar-tp-16 b-input"
                              maxLength={10}
                              value={formData.mobileNumber}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        {errors.mobileNumber && (
                          <div className="text-red-500">
                            {errors.mobileNumber}
                          </div>
                        )}
                        <input
                          type="text"
                          name="email"
                          placeholder={
                            isIPLContestEligible
                              ? "Enter your email *"
                              : "Enter your email (Optional)"
                          }
                          className="mar-tp-16 b-input"
                          maxLength={100}
                          value={formData.email}
                          onChange={handleInputChange}
                        />
                        {errors.email && (
                          <div className="text-red-500">{errors.email}</div>
                        )}

                        <select
                          className="form-control"
                          id="user_time_zone"
                          size="0"
                          name="onlineStore"
                          value={formData.onlineStore}
                          onChange={handleInputChange}
                        >
                          <option value="">
                            Select where you bought from *
                          </option>
                          {boughtFrom.map((item) => (
                            <option key={item.key} value={item.key}>
                              {item.value}
                            </option>
                          ))}
                        </select>

                        {errors.onlineStore && (
                          <div className="text-red-500 mb-3">
                            {/* errors.online Free */}
                          </div>
                        )}
                        <button type="submit">VERIFY</button>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="p-0 col-md-8">
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      <div
                        hidden={isIPLContestEligible}
                        className="carousel-item active"
                      >
                        <img
                          src="img/1.jpg"
                          className="d-block w-100"
                          alt="slider"
                          loading="lazy"
                        />
                      </div>
                      <div
                        hidden={!isIPLContestEligible}
                        className="carousel-item active pr-md-3"
                      >
                        <img
                          src="img/RCB Contest2.jpg"
                          className="d-block w-100"
                          alt="slider"
                          loading="lazy"
                          style={{
                            objectFit: "contain",
                            height: "100%",
                            width: "100%",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Dialog
            BackdropProps={{
              classes: {
                root: classes.backDrop,
              },
            }}
            open={isIPLContestDialog}
            onClose={setIsIPLContestDialog}
            className="add"
          >
            <DialogContent style={{ backgroundColor: "transparent" }}>
              <div style={{ display: "inline-block" }}>
                <IconButton
                  aria-label="close"
                  onClick={() => setIsIPLContestDialog(false)}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 15,
                    top: -5,
                    color: theme.palette.grey[500],
                    disableFocusRipple: "true",
                    border: 0,
                  })}
                >
                  ✖
                </IconButton>
              </div>
              <div style={{ display: "block" }}>
                <img
                  style={{ borderRadius: "15px" }}
                  src={ContestDialogImage}
                />
              </div>
            </DialogContent>
          </Dialog>

          <div className="footermy wow fadeIn" data-wow-delay="0.3s">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 ol-md-6 footer-links  social-icone boxxe">
                  <h2>Follow us by</h2>
                  <div className="icons_container">
                    <div className="icon facebook">
                      <div className="tooltip">Facebook</div>
                      <a
                        href="https://www.facebook.com/OptimumNutritionIN"
                        target="_blank"
                      >
                        {" "}
                        <span>
                          <i className="fa fa-facebook-f"></i>
                        </span>
                      </a>
                    </div>
                    <div className="icon instagram">
                      <div className="tooltip">Instagram</div>
                      <a
                        href="https://www.instagram.com/optimumnutri_in/"
                        target="_blank"
                      >
                        {" "}
                        <span>
                          <i className="fab fa-instagram"></i>
                        </span>
                      </a>
                    </div>
                    <div className="icon youtube">
                      <div className="tooltip">YouTube</div>
                      <a
                        href="https://www.youtube.com/user/OptimumNutriIN"
                        target="_blank"
                      >
                        <span>
                          <i className="fa fa-youtube"></i>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container footermy-menu">
              <div className="f-menu"></div>
            </div>
            <div className="container copyright">
              <div className="row">
                <div className="col-md-6 text-white copyright">
                  {" "}
                  © {new Date().getFullYear()} Optimum Nutrition, INC{" "}
                </div>
                <div className="col-md-6 text-right copyright designedby">
                  Design & Developed by{" "}
                  <a
                    href="https://holostik.com/"
                    className="desinged-by"
                    target="_blank"
                  >
                    Holostik India Limited
                  </a>
                </div>
              </div>
            </div>
          </div>
          <a href="#" className="back-to-top">
            <i className="fa fa-chevron-up" />
          </a>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
